import * as Yup from "yup";

export default Yup.object().shape({
    id: Yup.number(),
    projectLocationId: Yup.number().nullable(),
    abatedAmountAndType: Yup.string().nullable(),
});